<form [formGroup]="viewerSliderFilterForm" [aria-label]="label">
  <div class="form-field form-field__slider">
    @if (betweenInput) {
      @if (inputMode === "INPUT_FIELD" || inputMode === "SLIDER_AND_INPUT_FIELD") {
        <div class="range-inputs">
          <input
            matInput
            type="number"
            formControlName="lowerValue"
            [min]="minValue"
            [max]="maxValue"
            [value]="viewerSliderFilterForm.get('lowerValue')?.value"
            [aria-label]="labelLowerValue"/>
          <strong class="range-separator">-</strong>
          <input
            matInput
            type="number"
            formControlName="upperValue"
            [min]="minValue"
            [max]="maxValue"
            [value]="viewerSliderFilterForm.get('upperValue')?.value"
            [aria-label]="labelUpperValue"/>
        </div>
      }
      @if (inputMode === "SLIDER" || inputMode === "SLIDER_AND_INPUT_FIELD"){
        <tm-slider
          [min]="minValue"
          [max]="maxValue"
          [step]="stepSize"
          [betweenValues]="{
            lower: viewerSliderFilterForm.get('lowerValue')?.value ?? null,
            upper: viewerSliderFilterForm.get('upperValue')?.value ?? null,
          }"
          [displayWith]="displayWith"
          [displayLabels]="inputMode === 'SLIDER'"
          [labelsLowerAndUpperValue]="{labelLowerValue, labelUpperValue}"
          (betweenValuesChange)="changeBetweenValues($event)"></tm-slider>
      }
    } @else {
      @if (inputMode === "INPUT_FIELD" || inputMode === "SLIDER_AND_INPUT_FIELD") {
        <div class="single-input">
          <input
            matInput
            type="number"
            formControlName="filterValue"
            [min]="minValue"
            [max]="maxValue"
            [value]="viewerSliderFilterForm.get('filterValue')?.value"
            [aria-label]="label"/>
        </div>

      }
      @if (inputMode === "SLIDER" || inputMode === "SLIDER_AND_INPUT_FIELD") {
        <tm-slider
          [min]="minValue"
          [max]="maxValue"
          [step]="stepSize"
          [value]="viewerSliderFilterForm.get('filterValue')?.value"
          [displayWith]="displayWith"
          [displayLabels]="inputMode === 'SLIDER'"
          [label]="label"
          (valueChange)="changeValue($event)"></tm-slider>
      }
    }
  </div>
</form>

